import { render, staticRenderFns } from "./CargoStatus.vue?vue&type=template&id=23aeb87a&"
import script from "./CargoStatus.vue?vue&type=script&lang=js&"
export * from "./CargoStatus.vue?vue&type=script&lang=js&"
import style0 from "./CargoStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports